module.exports = __webpack_public_path__ + "june-24-3.jpg?ec7287622e483989a0d0e4e0cd25571b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/june-24-3.jpg
// module id = 218
// module chunks = 0